/*
    menu - link
*/
import $ from "../../util/dom-core.js";
import { getRandom } from "../../util/util.js";
import Panel from "../panel.js";
import { isURL } from "../../util/util.js";
// 构造函数
function Embed(editor) {
  this.editor = editor;
  this.$elem = $(
    '<div class="w-e-menu"><svg aria-hidden="true" class="ui-icon"><use xlink:href="#icon-Youtube"></use></svg></div>'
  );
  this.type = "panel";
  this.errorHandler = editor.errorHandler;
  // 当前是否 active 状态
  this._active = false;
}

// 原型
Embed.prototype = {
  constructor: Embed,

  // 点击事件
  onClick: function(e) {
    const editor = this.editor;
    let $linkelem;
    if (this._active) {
      // 当前选区在链接里面
      $linkelem = editor.selection.getSelectionContainerElem();
      if (!$linkelem) {
        return;
      }
      // 将该元素都包含在选取之内，以便后面整体替换
      editor.selection.createRangeByElem($linkelem);
      editor.selection.restoreSelection();
      // 显示 panel
      this._createPanel($linkelem.text(), $linkelem.attr("href"));
    } else {
      // 当前选区不在链接里面
      if (editor.selection.isSelectionEmpty()) {
        // 选区是空的，未选中内容
        this._createPanel("", "");
      } else {
        // 选中内容了
        this._createPanel(editor.selection.getSelectionText(), "");
      }
    }
  },

  // 创建 panel
  _createPanel: function(text, link) {
    // panel 中需要用到的id
    const inputLinkId = getRandom("input-link");
    const btnOkId = getRandom("btn-ok");
    const btnDelId = getRandom("btn-del");

    // 是否显示“删除链接”
    const delBtnDisplay = this._active ? "inline-block" : "none";

    // 初始化并显示 panel
    const panel = new Panel(this, {
      width: 300,
      // panel 中可包含多个 tab
      tabs: [
        {
          // tab 的标题
          title: "Youtube",
          // 模板
          tpl: `<div>
                            <input id="${inputLinkId}" type="text" class="block" value="${link}" placeholder="http://..."/></td>
                            <div class="w-e-button-container">
                                <button id="${btnOkId}" class="right">插入</button>
                                <button id="${btnDelId}" class="gray right" style="display:${delBtnDisplay}">删除链接</button>
                            </div>
                        </div>`,
          // 事件绑定
          events: [
            // 插入链接
            {
              selector: "#" + btnOkId,
              type: "click",
              fn: () => {
                // 执行插入链接
                const $link = $("#" + inputLinkId);
                const link = $link.val();
                this._parseLink(link);

                // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                return true;
              }
            },
            // 删除链接
            {
              selector: "#" + btnDelId,
              type: "click",
              fn: () => {
                // 执行删除链接
                this._delLink();

                // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                return true;
              }
            }
          ]
        } // tab end
      ] // tabs end
    });

    // 显示 panel
    panel.show();

    // 记录属性
    this.panel = panel;
  },

  //
  _parseLink: function(link) {
    const editor = this.editor;
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = link.match(regExp);

    if (match && match[2].length == 11) {
      editor.cmd.do(
        "insertHTML",
        `<iframe width="560" height="315" src="//www.youtube.com/embed/${
          match[2]
        }" frameborder="0" allowfullscreen></iframe>`
      );
    } else {
      editor.errorHandler("typeValidLink");
    }
  },

  // 删除当前链接
  _delLink: function() {
    if (!this._active) {
      return;
    }
    const editor = this.editor;
    const $selectionELem = editor.selection.getSelectionContainerElem();
    if (!$selectionELem) {
      return;
    }
    const selectionText = editor.selection.getSelectionText();
    editor.cmd.do("insertHTML", "<span>" + selectionText + "</span>");
  },

  // 试图改变 active 状态
  tryChangeActive: function(e) {
    const editor = this.editor;
    const $elem = this.$elem;
    const $selectionELem = editor.selection.getSelectionContainerElem();
    if (!$selectionELem) {
      return;
    }
    if ($selectionELem.getNodeName() === "A") {
      this._active = true;
      $elem.addClass("w-e-active");
    } else {
      this._active = false;
      $elem.removeClass("w-e-active");
    }
  }
};

export default Embed;
